const Links = [
    { url: '/events', text: 'イベントTOP' },
    { url: '/events/caravan', text: 'ドリームキャラバン' },
    { url: '/events/festa', text: 'フェスタ' },
    { url: '/events/treasure', text: 'トレジャー' },
    { url: '/events/roulette', text: 'ルーレットヒッター' },
    { url: '/events/rabyrinth', text: 'ラビリンス' },
    { url: '/events/tp', text: 'ターニングポイント' },
    { url: '/events/ranking', text: 'ランキング汎用' },
    { url: 'https://www.sakusaku27.com/', text: '集計方法' },
];

export default Links